import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        userInfo:null
    },
    mutations: {
        updateUserInfo(state,info) {  //s传入state对象
            // debugger
            state.userInfo= {...info}
        },
    },
    actions: {
        // addCountAction(context,n) {
        //     debugger
        //     context.commit('addCount',n)
        // }
    },
    modules: {},
})
